module.exports = "<p>roe-template works!</p>\n"